import produce from 'immer';

export const appState = {
    actives:{
        term: null,
        tab: null,
        set: null,
        instructor: null,
        department: null
    },
    schools: null,
    instructors: {
        // [schoolID]: {
        //   [termSchoolID]: [
        //     {
        //       ...data,
        //     },
        //   ],
        // },
    },
    departments: {
        //   [schoolID]: [
        //     {
        //         ...data
        //       },
        //   ]
    },
    sets: {
        //   [departmentID + termSchoolID]: [
        //     {
        //         ...data
        //       },
        //   ]
    },
    timetables: {
        // [timeTableID]: {
        //   ...data
        // }
    },
    examSchedules: {
        // [termSchoolID]: [
        //   {
        //     ...data
        //   }
        // ]
    }
};

export const appReducer = (state, action) => {
    const { payload } = action;

    return produce(state, (draft) => {
        switch (action.type) {
            case 'ADD_SCHOOLS':{
                draft.schools = payload;
                break;
            }

            case 'ADD_DEPARTMENTS':{
                draft.departments[payload.schoolID] = payload.departments;
                break;
            }

            case 'ADD_INSTRUCTORS':{
                if (draft.instructors[payload.schoolID]) {
                    draft.instructors[payload.schoolID][payload.termSchoolID] = payload.instructors;
                } else {
                    draft.instructors[payload.schoolID] = {
                        [payload.termSchoolID]: payload.instructors
                    };
                }
                break;
            }

            case 'ADD_SETS':{
                draft.sets[payload.departmentID + payload.termSchoolID] = payload.sets;
                break;
            }

            case 'ADD_TIMETABLE':{
                draft.timetables[payload.id] = payload.timetable;
                break;
            }

            case 'ADD_EXAM_SCHEDULES':{
                draft.examSchedules[payload.termSchoolID] = payload.examSchedules;
                break;
            }

            case 'ADD_ACTIVES':{
                let newActives = {
                    ...draft.actives
                }
                newActives[payload.key] = payload.value;
                if(payload.key === 'set'){
                    newActives.instructor = null;
                }
                else if(payload.key === 'instructor'){
                    newActives.set = null;
                }

                draft.actives = newActives;
                break;
            }

            case 'SET_TO_NULL_ACTIVES':{
                let actives = {
                    ...draft.actives
                }
                payload.map((p) => actives[p] = null);
                draft.actives = actives;
                break;
            }

            case 'CLEAR_DATA':{
                break;
            }

            default:
        }
    });
};
